












































































































































































import { Component, Vue } from "vue-property-decorator";
import store from "@/store";
import { AppConstants } from '@/core/Export';

@Component({ components: {} })
export default class AppBlankLayout extends Vue {
  hourOfDay:number;
  greetingMessage : string;
  constructor() {
    super();
  }

  created() {
    this.onCloseDisplayMsgsInLogintDialogTimeout();
    this.typeOfGreetingMessage();
  }

  onActivateApprovalsList(isFromManager: boolean) {
    store.commit(AppConstants.StoreMutations.UpdateIsLeftDrawerOpen, true);
    store.commit(AppConstants.StoreMutations.UpdateLeftDrawerComponnent, AppConstants.DrawerComponnents.ApprovalsList);
    store.commit(AppConstants.StoreMutations.UpdateDrawerParams, { employeeId: this.appEnv.UserInfo.employeeId, isFromManager: isFromManager });
    if (isFromManager) {
      this.onCloseManagerApprovalsListDialog();
    } else {
      this.onCloseEmpApprovalsListDialog();
    }
  }
  onCloseDisplayMsgsInLogintDialog() {
    setTimeout(() => {
        this.appEnv.isDisplayMsgsInLogin = false;
      }, 3000);
    this.appEnv.isDisplayMsgsInLogin = false;
  }

  onCloseDisplayMsgsInLogintDialogTimeout() {
    setTimeout(() => {
        this.appEnv.isDisplayMsgsInLogin = false;
      }, 3000);
  }

  typeOfGreetingMessage() {
    let today = new Date();
    this.hourOfDay = today.getHours();
    if(this.hourOfDay>= 5 && this.hourOfDay < 12){
      this.greetingMessage = "msgs.good_morning";
    }
    else if(this.hourOfDay>= 12 && this.hourOfDay < 18){
      this.greetingMessage = "msgs.good_afternoon";
    }
    else{
      this.greetingMessage = "msgs.good_evening";
    }
  }


  onCloseEmpApprovalsListDialog() {
    this.appEnv.isEmpApprovalsListDialogVisible = false;
  }

  onCloseManagerApprovalsListDialog() {
    this.appEnv.isManagerApprovalsListDialogVisible = false;
  }

  onCloseErrorDialog() {
    this.appEnv.isErrorDialogVisible = false;
    this.appEnv.errorDialogMsgs = [];
  }

  onCloseInfoDialog() {
    this.appEnv.isInfoDialogVisible = false;
    this.appEnv.infoDialogMsgs = [];
    this.appEnv.infoDialogPromiseResolve();
  }

  get noOfManagerApprovals() {
    if (this.appEnv.UserInfo && this.appEnv.UserInfo.approvals) {
      return this.appEnv.UserInfo.approvals.noOfManagerApprovals;
    }
    return null;
  }

  get appEnv() {
    return store.state.appEnv;
  }

  get displayNameForLogin() {
    if(this.appEnv.UserInfo!=undefined)
      return this.appEnv.UserInfo.displayName;
    else
      return "";  
  }
  
}
